import React from 'react';
import { Box } from 'theme-ui';
import { Link } from 'react-scroll';

const RenderSideList = ({ sideNavSliderItems }) => {
  return (
    <Box sx={stickyNav}>
      <Box sx={stickyNav.wrap}>
        {sideNavSliderItems.map((item) =>
          item.carousel.length > 0 ? (
            <Box sx={stickyNav.item} key={Math.random().toString(36).substring(7)}>
              <Link to={item.title} offset={-40} spy smooth activeClass="isActive">
                {item.title}
              </Link>
            </Box>
          ) : (
            <></>
          )
        )}
      </Box>
    </Box>
  );
};

const stickyNav = {
  right: [null, null, 0],
  left: [0, null, 'auto'],
  zIndex: 5,
  position: 'sticky',
  float: [null, null, 'right'],
  top: 0,
  height: [null, null, '100vh'],
  display: 'flex',
  py: [null, null, 4],
  px: 2,
  backgroundColor: 'background',
  variant: 'styles.flexCenter',
  wrap: {
    display: 'flex',
    overflow: 'auto',
    whiteSpace: ['nowrap', null, null],
    writingMode: [null, null, 'vertical-rl'],
  },
  item: {
    fontSize: 1,
    flexShrink: 0,
    '> a': {
      py: [2, null, 3],
      px: 2,
      cursor: 'pointer',
      display: 'block',
      userSelect: 'none',
    },
    '> a.isActive': {
      fontWeight: 'bold',
    },
  },
};

export default RenderSideList;
